import { ErrorCodes } from "./errorCodes";

export class BeanzConnectError extends Error {
  public errorCode = "";
  constructor(message: string, attributes?: Record<string, string | number | ErrorCodes | undefined>, detailedMessage?: string) {
    super(message);
    this.cause = {};
    if (attributes) {
      this.errorCode = attributes.errorCode === undefined ? "" : String(attributes.errorCode);
      delete attributes.errorCode;
      this.cause = attributes;
    }
    if (detailedMessage) {
      (this.cause as Record<string, string>).details = detailedMessage;
    }
  }

  getCause = (): Record<string, string> => {
    return this.cause as Record<string, string>;
  };
}

export class BadRequestError extends BeanzConnectError {}

export class NotFoundError extends BeanzConnectError {}

export class PartialError extends BeanzConnectError {}

export class MultiStatus extends BeanzConnectError {}

export class ConflictError extends BeanzConnectError {}

export class InternalError extends BeanzConnectError {}

/** The PIM products API could not be walked completely (failed, truncated, inconsistent or oversized result). */
export class PimRetrievalError extends InternalError {}

export class ForbiddenError extends BeanzConnectError {}

export class ServiceUnavailableError extends BeanzConnectError {}

export class TooManyRequestsError extends BeanzConnectError {}

export class CarrierDetailsMissingError extends BeanzConnectError {}

export class UnsupportedMediaTypeError extends BeanzConnectError {
  constructor(detail?: string) {
    super("Unsupported Media Type", undefined, detail);
  }
}

export class GrindTypeNotFoundError extends Error {
  constructor(d365SkuId: string) {
    super(`No Grind-Type found for D365 SKU: ${d365SkuId}`);
  }
}
